var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('article',{staticClass:"first"},[_vm._v(" La rubrique d'aide sera bientôt disponible. ")])])
}]

export { render, staticRenderFns }